import { locationIndexValidate } from "../../application/dtos/location_index_validate";

export class locationIndexEntity {
    constructor({ id, name, is_available, stacking_level, warehouse }){
        this.id = id;
        this.name = name;
        this.is_available = is_available;
        this.stacking_level = stacking_level;
        this.warehouse = warehouse;
    }

    isValid() {
        return locationIndexValidate(this);
    }
}